module.exports = __webpack_public_path__ + "img/04.b782e80b.png";